export default "__VITE_ASSET__3284b3b4__"